
 /**
    A-K
    0-12
*/

import data_control from "../../../../../../engines/libs/data_control";
import { HappyWinKind } from "./HappyWinKind";


/** 牌型数据区间 */
const CardTypeArea = [
    0, 12
]


export class HappyWinDataManage {

    /**
     * 生成参照区的牌
     * @param type 
     * @param excludeArr 
     * @returns 
     */
    static generateCardTypeRefer(
        excludeArr: number[]
    ) {
        const c_space = 2;
        let min = 0;
        let max = HappyWinKind.CardData.length-1;
        let cardData: number[] = [];

        while(true) {
            let minMax = max - c_space;
            let randMin = data_control.randomNumInt(min, minMax);
            if (excludeArr.includes(randMin)) {
                continue;
            }
            let randMax = data_control.randomNumInt(randMin+c_space, max);
            if (excludeArr.includes(randMax)) {
                continue;
            }
            cardData.push(randMin, randMax);
            break;
        }
        return cardData;
    }

    /**
     * 生成牌组合区的牌
     * @param type 
     * @param oCardData 
     * @param oCardType 
     * @param bWin 
     * @returns 
     */
    static generateCardTypeCom(
        cardRange: number[]
        , bWin: boolean
    ) {
        let min = cardRange[0];
        let max = cardRange[1];
        if (bWin) {
            let card2 = data_control.randomNumInt(min+1, max-1);
            return card2;
        } 

        let minRange = 0;
        let maxRange = HappyWinKind.CardData.length-1;
        if (min <= minRange && max >= maxRange) {
            console.error('数据错误');
            return;
        }
        let bMin = data_control.isHitProbability(0.5);
        let card = 0;
        if (min > minRange && (bMin || max >= maxRange)) {
            card = data_control.randomNumInt(minRange, min-1);
        } else {
            card = data_control.randomNumInt(max+1, maxRange);
        }
        return card;
    }
}